// Update contents object below

const contents = {
  header: 'Destination Canada',
  logoTooltip: {
    href: 'https://us-keepexploring.canada.travel/',
    copy: 'https://us-keepexploring.canada.travel/',
    logoPlacement: 'above'
  },
  video:
    'https://player.vimeo.com/video/786660704?h=96987234a5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  videoTitle: 'Destination Canada - Ep. 3 British Columbia',
  videoAutoPlay: true,
  title: 'episode 3: British Columbia',
  copy:
    'This entrepreneur and advocate finds freedom in the wild views and craggy peaks of British Columbia ⁠— and explores the power of decompression, relaxation, and uniquely enriching Canadian experiences.',
  url: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
  button: 'return to hub',
  url2: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/yukon/'
};

export default contents;
